const outcomes = [{
    title: "The Icons",
    range: "Fashion",
    text: "G-SHOCK's iconic designs, including the best-selling octagonal 2100 alongside the square 5600 and triple-graph 6900, represent an evolution of the original G-SHOCK watches since 1983. In a short space of time, these models have made a powerful impact on street culture with their toughness, functionality, and bold design, setting a new standard for the entire G-SHOCK lineup.",
    url: "https://www.casio.com/uk/watches/gshock/products/collection/the-icons/",
    video: "gshock-fashion-desktop.mp4",
    videoMobile: "gshock-fashion-desktop.mp4",
    recommendedProducts: [{
            title: "GA-B2100",
            image: "fashion4-GA-B2100-1A1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/products/collection/ga-b2100-collection/",
        },
        {
            title: "DW-5600",
            image: "fashion1-DW-5600RL-1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/products/collection/5600-5000/",
        },
        {
            title: "DW-6900",
            image: "fashion2-DW-6900TR-4.jpg",
            url: "https://www.casio.com/uk/watches/gshock/products/collection/6900/",
        },
        {
            title: "GA-110",
            image: "fashion3-GA-110HDS-7A.jpg",
            url: "https://www.casio.com/uk/watches/gshock/products/collection/110-collection/",
        },
    ],
},
{
    title: "Sports Range",
    range: "Sport",
    text: "G-SHOCK Sports Watches are built to withstand knocks and bumps even in the harshest environments, they also encompass daily health and fitness support functions. Featuring built in step tracking and a whole variety of individual sports tracking functions, helping you to monitor your fitness routines in the CASIO watches app.",
    url: "https://www.casio.com/uk/watches/types/sport-watches.filter.gshock-K84vKnGqtM1LLU8tLlErTi3KTC221U@XLc7IT84GAA%3D%3D/",
    video: "gshock-sport-desktop.mp4",
    videoMobile: "gshock-sport-desktop.mp4",
    recommendedProducts: [{
            title: "GBD-B500-1ER",
            image: "sport4-GD-B500-1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GD-B500-1/", 
        },
        {
            title: "GBA-900CB",
            image: "sport2-GBA-900CB-1A.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GBA-900CB-1A/",
        },
        {
            title: "GBD-200UU",
            image: "sport3-GBD-200UU-1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GBD-200-9/",
        },
        {
            title: "GBA-800",
            image: "sport1-GBA-800-1A_Seq1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GBA-800-1A/",
        },
    ],
},
{
    title: "GWG-B1000 Mudmaster",
    range: "Master of G",
    text: "Master of G watches are ruggedly stylish, and admired among G-SHOCK enthusiasts. MOG watches are worn by the military with G-SHOCK also collaborating with the Ministry Of Defence on a number of collections. The watches are loved thanks to their extreme shock resistance and ability to perform in various environments around the world.",
    url: "https://gshock.casio.com/uk/products/master-of-g/",
    video: "gshock-master-of-g-desktop.mp4",
    videoMobile: "gshock-master-of-g-desktop.mp4",
    recommendedProducts: [{
            title: "GG-B100-1AER",
            image: "mog1-GG-B100-1A_Seq1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GG-B100-1A/",
        },
        {
            title: "GWG-B1000-3AER",
            image: "mog2-GG-B100-1A3_Seq1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GWG-B1000-3A/",
        },
        {
            title: "GWG-B1000EC-1AER",
            image: "mog3-GWG-B1000-3A.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GWG-B1000EC-1A/",
        },
        {
            title: "GG-B100-1A3ER",
            image: "mog4-GWG-B1000EC-1A.jpg",
            url: "https://www.casio.com/uk/watches/gshock/product.GG-B100-1A3/",
        },
    ],
},
{
    title: "Metal Collection",
    range: "Metal",
    text: "Offering smart yet adaptable premium timepieces, the metal collection boasts show stopping sleek designs that are bound to be noticed in any outfit or occasion whilst also offering fantastic adaptability thanks to the sheer level of durability, quality and shock resistance each one provides.",
    url: "https://www.casio.com/uk/watches/types/stainless-steel-watches.filter.gshock-IN_STOCK-metals-metals-m-metalt-solid-K84vKnGqtM1LLU8tLlErTi3KTC221U@XLc7IT85W0youAVLBJYklpcW2nn7xwSH%2Bzt5qSYl5Kbb6uakliTm6xTowhm4ujFmio1%2Bcn5OZAgA%3D/",
    video: "gshock-metal-desktop.mp4",
    videoMobile: "gshock-metal-desktop.mp4",
    recommendedProducts: [{
            title: "GM-2110D",
            image: "metal2-GM-2110D-4A.jpg",
            url: "https://www.casio.com/uk/search/?query=GM-2110D",
        },
        {
            title: "GMW-B5000",
            image: "metal3-GMW-B5000D-3.jpg",
            url: "https://www.casio.com/uk/search/?query=GMW-B5000",
        },
        {
            title: "GBM",
            image: "metal1-GBM-2100A-2B.jpg",
            url: "https://www.casio.com/uk/search/?query=gbm&type=product&stockStatus=inStock",
        },
        {
            title: "MRG",
            image: "metal4-MRG-B5000BA-1.jpg",
            url: "https://www.casio.com/uk/watches/gshock/products/mr-g/",
        },
    ],
},
];

export default outcomes;